import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import type { FilterOptions, GetOptions, PaginationOptions, RequestConfig } from 'api/types';
import type { MeetingRequestFilters } from 'constants/meetingRequestFilters';

export type ClientMeetingRequestsGetOptions = GetOptions &
  PaginationOptions &
  FilterOptions<MeetingRequestFilters>;

export function clientMeetingRequestsApi(path: string) {
  return {
    path,
    GET: (params: ClientMeetingRequestsGetOptions = {}, config?: RequestConfig) => {
      const { pageSize, pageNumber, ...rest } = params;

      return api.get<JsonApiResponse>(path, {
        params: {
          per_page: pageSize,
          page: pageNumber,
          ...rest,
        },
        ...config,
      });
    },
  };
}
